import { TOGGLE_ASSET_STATUS, TOGGLE_STRING_DEBUG } from './dev-keys';
import { getCookie } from '../../utils/cookie';

export function isStringDebugEnabled(state) {
  return state.dev[TOGGLE_STRING_DEBUG];
}

export function pointingToProd() {
  return getCookie('productionJigsaw') === 'true';
}

export function isAssetStatusEnabled(state) {
  return state.dev[TOGGLE_ASSET_STATUS];
}
